module.exports = __webpack_public_path__ + "files/10f4b956ec4d7e11c2b0c1cc11e18db1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/alpha.png
 ** module id = 389
 ** module chunks = 0
 **/